module.exports = __webpack_public_path__ + "img/clock-normal.2ae8beeb.svg";